import { generateSourcingTemplate } from 'modules/sourcing-shared/services';
import { STARTING_TEMPLATED_MESSAGE_SMS } from 'modules/sourcing-shared/constants';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { Channels } from 'generated-graphql/types';

type GenerateStartingTemplatedMessageControllerProps = {
  jobDescription: string;
  jobTitle: string | null | undefined;
  employerName: string | null | undefined;
  channel: Channels;
  get: SharedSourcingStoreApi['getState'];
  set: SharedSourcingStoreApi['setState'];
};

export const generateStartingTemplatedMessageController = async ({
  jobDescription,
  jobTitle,
  employerName,
  channel,
  get,
  set
}: GenerateStartingTemplatedMessageControllerProps) => {
  const {
    isDefaultStartingTemplatedMessageLoading,
    defaultStartingTemplatedMessage
  } = get();

  if (isDefaultStartingTemplatedMessageLoading) return;
  if (defaultStartingTemplatedMessage) return;

  try {
    set({ isDefaultStartingTemplatedMessageLoading: true });

    if (channel === Channels.Sms) {
      set({ defaultStartingTemplatedMessage: STARTING_TEMPLATED_MESSAGE_SMS });
      return;
    }

    const defaultStartingTemplatedMessage = await generateSourcingTemplate({
      jobDescription,
      jobTitle,
      employerName,
      channel
    });

    set({ defaultStartingTemplatedMessage });
  } finally {
    set({ isDefaultStartingTemplatedMessageLoading: false });
  }
};
